import AuthApi from "../../../services/api/authApi.js";

const AuthApiService = new AuthApi();

export default {
  data() {
    return {
      model: {
        email: "",
      },
    };
  },

  methods: {
    submit,
  },
};

async function submit() {
  if (!(await this.$validator.validate())) {
    return;
  }

  const _self = this;

  AuthApiService.forgotPassword({
    email: _self.model.email,
  })
    .then(() => {
      _self.$swal("Success", "Email with password reset code is on its way!");
      _self.$router.push("/sign-in");
    })
    .catch((error) => {
      if (error.response) {
        _self.$swal("Attention", error.response.data.error_message);
      } else {
        _self.$logger.notify(new Error(error));
      }
    });
}
